import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconContentFullWidth = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 8.25C6.08579 8.25 5.75 8.58579 5.75 9C5.75 9.41421 6.08579 9.75 6.5 9.75H17.5C17.9142 9.75 18.25 9.41421 18.25 9C18.25 8.58579 17.9142 8.25 17.5 8.25H6.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.75 12C5.75 11.5858 6.08579 11.25 6.5 11.25H17.5C17.9142 11.25 18.25 11.5858 18.25 12C18.25 12.4142 17.9142 12.75 17.5 12.75H6.5C6.08579 12.75 5.75 12.4142 5.75 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 14.25C6.08579 14.25 5.75 14.5858 5.75 15C5.75 15.4142 6.08579 15.75 6.5 15.75H17.5C17.9142 15.75 18.25 15.4142 18.25 15C18.25 14.5858 17.9142 14.25 17.5 14.25H6.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 2.25C3.92893 2.25 2.25 3.92893 2.25 6V18C2.25 20.0711 3.92893 21.75 6 21.75H18C20.0711 21.75 21.75 20.0711 21.75 18V6C21.75 3.92893 20.0711 2.25 18 2.25H6ZM3.75 6C3.75 4.75736 4.75736 3.75 6 3.75H18C19.2426 3.75 20.25 4.75736 20.25 6V18C20.25 19.2426 19.2426 20.25 18 20.25H6C4.75736 20.25 3.75 19.2426 3.75 18V6Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconContentFullWidth as ReactComponent };
